import React, { Component } from 'react';
import UpdateEmailHeader from './UpdateEmailHeader';
import UpdateEmailFooter from './UpdateEmailFooter';
import './UpdateEmailLayout.scss';

class UpdateEmailLayout extends Component {
  render() {
    return (
      <div className="hrb-update-email-layout">
        <UpdateEmailHeader />
        <div className="hrb-update-email-layout-content">
          {this.props.children}
        </div>
        <UpdateEmailFooter />
      </div>
    );
  }
}

export default UpdateEmailLayout;
